var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconWeight = function SvgIconWeight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6.17mm",
    height: "6.24mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17.5 17.68",
    fill: "#717679",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.02,16.22l-2.66-9.96c-.12-.45-.53-.76-.99-.76h-2.36c.53-.56.86-1.32.86-2.15,0-1.74-1.42-3.15-3.15-3.15s-3.15,1.41-3.15,3.15c0,.83.33,1.59.86,2.15h-2.53c-.47,0-.88.32-1,.78L.42,16.24c-.08.31,0,.63.19.88.2.25.49.39.81.39h14.62c.32,0,.62-.15.81-.4.2-.25.26-.58.18-.89ZM6.57,3.35c0-1.19.97-2.15,2.15-2.15s2.15.97,2.15,2.15-.97,2.15-2.15,2.15-2.15-.97-2.15-2.15ZM16.03,16.51l-14.65-.03L3.9,6.5l9.5.02,2.65,9.98s-.02.01-.02.01Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconWeight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-weight.9f30505faa784f192d877f57e0aa4138.svg";